module.exports = __webpack_public_path__ + "static/serpent-spine-3a5e00cdd90d8cc638e746124931855b.png";